import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ViToastService } from '@vi-iot/ui';

@Injectable({
  providedIn: 'root',
})
export class InvitationsMessagesService {
  toastData = {
    accept: {
      actionBtnName: '+INVITATIONS.INVITATIONS.INVITATION.ACCEPT_SNACKBAR.BUTTON',
      navigateTo: '/installations',
      message: '+INVITATIONS.INVITATIONS.INVITATION.ACCEPT_SNACKBAR.MESSAGE',
      created: '+INVITATIONS.INVITATIONS.INVITATION_CREATED',
    },
    reject: {
      message: '+INVITATIONS.INVITATIONS.INVITATION.REJECT_SNACKBAR.MESSAGE',
    },
    cancel: {
      message: '+INVITATIONS.INVITATIONS.INVITATION.CANCEL_SNACKBAR.MESSAGE',
    },
  };

  constructor(private viToastService: ViToastService, private translation: TranslateService) {}

  onAcceptSuccess(ownerName: string): void {
    const name = this.translation.instant(this.toastData.accept.actionBtnName);
    const message: string = this.translation.instant(this.toastData.accept.message);
    this.viToastService.info({
      message: message.replace(/{{ownerName}}/gi, ownerName),
      actions: [
        {
          id: 'navigate-btn',
          name,
          raised: true,
          navigate: this.toastData.accept.navigateTo,
        },
      ],
    });
  }

  onRejectSuccess(ownerName: string): void {
    const message: string = this.translation.instant(this.toastData.reject.message);
    this.viToastService.info({
      message: message.replace(/{{ownerName}}/gi, ownerName),
    });
  }

  onCancelSuccess(): void {
    this.viToastService.info({
      message: this.translation.instant(this.toastData.cancel.message),
    });
  }

  onSendSuccess(): void {
    this.viToastService.info({
      message: this.translation.instant(this.toastData.accept.created),
    });
  }
}
